import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Popconfirm, message} from 'antd';
import {SmallPopover, modal} from 'icsoc-antd-ex';
import UnionTableList from 'Components/union/unionTableList';
import CommonTable from 'Components/common/commonTable';
import TableBottomActions from 'Components/common/commonTable/tableBottomActions';
import IconFont from 'Components/common/iconFont';
import newRoleActions from 'Actions/systemSetting/newRole';
// import tWorkTimeActions from 'Actions/systemSetting/workTime';
// import {getByteLen, cutStr} from 'Utils';
// import moment from 'moment';

const {modalTips} = modal;
const columns = (pageStatus, handleAction,login) => [
  {
    title: '角色名称',
    key: 'name',
    dataIndex: 'name',
    width: 150,
    render: text => text || '--',
    ellipsis: true,
    // fixed: 'left',
  },
  {
    title: '描述',
    dataIndex: 'desc',
    key: 'desc',
    width: '15%',
    render: text => text || '--',
    ellipsis: true,
  },
  {
    title: '用户数',
    dataIndex: 'userNum',
    key: 'userNum',
    width: 100,
    render: text => text || '--',
    ellipsis: true,
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    key: 'createTime',
    width: 150,
    render: text => text || '--',
  },
  {
    title: '修改时间',
    dataIndex: 'updateTime',
    key: 'updateTime',
    width: 150,
    render: text => text || '--',
  },
  {
    title: '最近修改人',
    dataIndex: 'updateUser',
    key: 'updateUser',
    width: 100,
    render: text => text || '--',
    ellipsis: true,
  },
  {
    title: '操作',
    dataIndex: 'operate',
    key: 'operate',
    width: 120,
    fixed: 'right',
    render: (text, record) => (
      <div className="operate">
        {
          login.permissionsList.includes('systemSettingRoleManagement.edit') ?
          <SmallPopover type="white" content="编辑" className="tooltip">
            <IconFont
              type="icon-robotedit"
              onClick={() => handleAction('editRole', record)}
            />
          </SmallPopover>
        : null}
        {
          login.permissionsList.includes('systemSettingRoleManagement.addUser') ?
          <SmallPopover type="white" content="添加用户" className="tooltip">
            <IconFont
              type="icon-robotcontacts"
              onClick={() => handleAction('addUser', record)}
            />
          </SmallPopover>
        : null}
        {
           login.permissionsList.includes('systemSettingRoleManagement.delete') ?
           <SmallPopover type="white" content="删除" className="tooltip">
            <Popconfirm
              placement="leftBottom"
              title={`确定删除【${record.name}】角色吗？`}
              onConfirm={() => {
                handleAction('confirmDelete', [record.id]);
              }}>
              <IconFont type="icon-robottrash" />
            </Popconfirm>
           </SmallPopover>
        : null}
      </div>
    ),
  },
];

class TableList extends UnionTableList {
  constructor(props) {
    super(props);

    this.state = {
      selectedRowKeys: [],
    };
  }

  // 列表选择
  onSelectChange = selectedRowKeys => {
    this.setState({selectedRowKeys});
  };

  // 批量删除
  batchDelete = () => {
    const {selectedRowKeys} = this.state;

    modalTips({
      // icon:'',
      centered: true,
      type: 'error',
      title: '提示',
      content: `您确定要删除选中的${selectedRowKeys.length}个角色吗？`,
      onOk: () => this.confirmDelete(selectedRowKeys),
    });
  };

  handleAction = (type, id) => {
    this[type](id);
  };

  // 编辑角色
  editRole = record => {
    const {setNewRoleVisible, actions, newRoleData} = this.props;
    actions
      .setNewRoleData({roleId: record.id, name: record.name, desc: record.desc})
      .then(() => {
        setNewRoleVisible('edit', {
          roleId: record.id,
          name: record.name,
          desc: record.desc,
          deptselect: record.deptselect,
        });
      });
  };

  // 添加用户
  addUser = record => {
    const {setAddUserVisible, actions} = this.props;
    actions.setAddUserData({...record});
    setAddUserVisible();
  };

  // 删除角色
  confirmDelete = (id = []) => {
    const {
      searchData: {name},
      actions,
      setTableListLoading,
      getTableList,
      pageStatus: {pageNum, pageSize},
      tableListData: {total = 0} = {},
    } = this.props;
    const params = {
      roleIds: id,
    };

    setTableListLoading();
    actions
      .deleteRole(params)
      .then(res => {
        const {payload: {code} = {}} = res || {};

        if (parseInt(code, 10) === 200) {
          message.success('删除成功！');
          this.setState({
            selectedRowKeys: [],
          });
          const {roleIds} = params;
          const newPageNum = Math.ceil((total - roleIds.length) / pageSize);
          const turnPageNum = pageNum < newPageNum ? pageNum : newPageNum || 1;

          this.setPageStatus({
            pageNum: turnPageNum,
          });
          getTableList({
            name,
            pageNum: turnPageNum,
            pageSize,
          });
        }
      })
      .finally(() => {
        setTableListLoading();
      });
  };

  render() {
    const {
      tableListData: {data = [], total = 0} = {},
      loading,
      pageStatus,
      login
    } = this.props;
    const {selectedRowKeys} = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };

    return (
      <CommonTable
        tableLayout='fixed'
        style={{marginTop: 20}}
        columns={columns(pageStatus, this.handleAction,login)}
        rowSelection={rowSelection}
        dataSource={[...data]}
        rowKey="id"
        loading={loading}
        extraHeight={20}
        scroll={{x: 1500}}
        onChange={this.handleTableChange}
        pagination={{
          current: pageStatus.pageNum,
          total: total && parseInt(total, 10),
          pageSize: pageStatus.pageSize,
          showTotal: () => (
            <TableBottomActions
              showTotalRender={`共 ${total} 条`}
              selects={login.permissionsList.includes('systemSettingRoleManagement.batchDelete') ? selectedRowKeys.length :undefined}
              isMore={false}
              showButtons="2"
              contents={login.permissionsList.includes('systemSettingRoleManagement.batchDelete') ? [{name: '批量删除', action: this.batchDelete}] : null}
            />
          ),
        }}
      />
    );
  }
}

const mapStateToProps = ({systemSettingNewRole,login}) => ({
  tableListData: systemSettingNewRole.tableListData,
  pageStatus: systemSettingNewRole.pageStatus,
  searchData: systemSettingNewRole.searchData,
  newRoleData: systemSettingNewRole.newRoleData,
  login
});

const mapDispatchToProps = dispatch => ({
  // actions: bindActionCreators(tWorkTimeActions, dispatch),
  actions: bindActionCreators(newRoleActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableList);
